import { render, staticRenderFns } from "./ViewPage.vue?vue&type=template&id=d509717a&scoped=true"
import script from "./ViewPage.vue?vue&type=script&lang=js"
export * from "./ViewPage.vue?vue&type=script&lang=js"
import style0 from "./ViewPage.vue?vue&type=style&index=0&id=d509717a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d509717a",
  null
  
)

export default component.exports